<cs-card-list>
  <cs-card class="instructions-card">
    <p class="instruction-text">{{ message }}</p>
    <p class="instructions-title">{{ LL.cameraPermission.title() }}</p>
    <ul class="instructions-list">
      @for (step of steps; track $index) {
        <li>{{ step }}</li>
      }
    </ul>
  </cs-card>
</cs-card-list>
